/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leavetitle2Inputs */

const zh_organizationsettings_leavetitle2 = /** @type {(inputs: Organizationsettings_Leavetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定离开组织？`)
};

const en_organizationsettings_leavetitle2 = /** @type {(inputs: Organizationsettings_Leavetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave organization?`)
};

const es_organizationsettings_leavetitle2 = /** @type {(inputs: Organizationsettings_Leavetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Abandonar organización?`)
};

/**
* | output |
* | --- |
* | "Leave organization?" |
*
* @param {Organizationsettings_Leavetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leavetitle2 = /** @type {((inputs?: Organizationsettings_Leavetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leavetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leavetitle2(inputs)
	if (locale === "en") return en_organizationsettings_leavetitle2(inputs)
	return es_organizationsettings_leavetitle2(inputs)
});
export { organizationsettings_leavetitle2 as "organizationSettings_leaveTitle" }